
export enum DensitySourceCd {
	HYBRID = 'Hybrid',
	MANL = 'Manl',
	PRFL = 'Prfl'}

